module.exports = __webpack_public_path__ + "08_mole.7f36c52e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/08_mole.png
// module id = 1/Qh
// module chunks = 0